/*
 * @Description: 报到率饼图
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-06 15:39:51
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-08 17:06:50
 */
import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/pie'
import styles from './styles.css'

export default class _CenterTop2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  /**
   * * 构造报到率饼图
   * @memberof Home
   */
  getPieOption = () => {
    const { panelData = {} } = this.props

    const { zbdrs = 0, zrs = 0, bdl = 0 } = panelData
    const option = {
      // 鼠标选中提示
      tooltip: {
        trigger: 'item',
      },
      series: [
        {
          name: '报到统计',
          type: 'pie', //饼图
          clockWise: true,
          radius: ['55%', '75%'], //echarts图形状
          itemStyle: {
            /* 不显示标签 */
            normal: {
              label: { show: false },
              labelLine: { show: false },
            },
          },
          hoverAnimation: false, //禁止悬浮动画
          // 数据源
          data: [
            {
              name: '报到人数',
              value: zbdrs,
              itemStyle: {
                normal: {
                  color: '#2c6ce2',
                },
              },
            },
            {
              name: '入学总人数',
              value: zrs,
              itemStyle: {
                normal: {
                  color: '#f6a56a',
                },
              },
            },
          ],
        },
      ],
    }
    return option
  }

  render() {
    const { zbdrs = 0, zrs = 0, bdl = 0 } = this.props.panelData
    // 计算报到率
    const pieTitleText = `${bdl * 100}%`
    return (
      <div className={styles.box_2_top_com}>
        <div className={styles.pie_l}>
          {/* 饼图 */}
          <ReactEchartsCore
            style={{ width: '100%', height: '100%' }}
            echarts={echarts}
            option={this.getPieOption()}
            notMerge={true}
            lazyUpdate={true}
          />
        </div>
        <div className={styles.pie_r}>
          <span className={styles.pie_span1}>{pieTitleText}</span>
          <span className={styles.pie_span2}>报到率</span>
          <div className={styles.pie_lend}>
            <div
              style={{
                margin: '3px 2px',
                backgroundColor: '#2c6ce2',
                width: '13px',
                height: '13px',
                borderRadius: '50%',
              }}
            ></div>
            <span
              style={{ textAlign: 'left', fontSize: '12px', width: '75px' }}
            >
              已报到人数
            </span>
            <span>{zbdrs}人</span>
          </div>
          <div className={styles.pie_lend}>
            <div
              style={{
                margin: '3px 2px',
                backgroundColor: '#f6a56a',
                width: '13px',
                height: '13px',
                borderRadius: '50%',
              }}
            ></div>
            <span
              style={{ textAlign: 'left', fontSize: '12px', width: '75px' }}
            >
              入学总数
            </span>
            <span>{zrs}人</span>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/Show-new/_CenterTop2.js